module.exports = __webpack_public_path__ + "assets/img/Back_005.79bbbdcd-ps.png";